document.documentElement.classList.remove('no-js');

const configuredRoutes = window.PK9_ROUTES || {};
const storefrontRoot = configuredRoutes.root || '/';
const storefrontRoute = (path) => `${storefrontRoot.endsWith('/') ? storefrontRoot : `${storefrontRoot}/`}${path}`;
const statusNode = document.querySelector('[data-pk9-status]');
const announce = (message) => {
  if (!statusNode) return;
  statusNode.textContent = '';
  requestAnimationFrame(() => { statusNode.textContent = message; });
};

const money = (cents) => {
  const currency = window.Shopify?.currency?.active || 'EUR';
  return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
    style: 'currency', currency
  }).format(cents / 100);
};

const escapeHtml = (value) => String(value || '')
  .replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;')
  .replaceAll('"', '&quot;').replaceAll("'", '&#039;');

const cartShell = document.querySelector('[data-cart-shell]');
const cartDrawer = document.querySelector('[data-cart-drawer]');
let lastCartTrigger = null;
let lastSizeGuideTrigger = null;

const fetchCart = () => fetch(storefrontRoute('cart.js'), { headers: { Accept: 'application/json' } }).then((response) => {
  if (!response.ok) throw new Error('Cart fetch error');
  return response.json();
});

const updateCartCount = (count) => {
  document.querySelectorAll('[data-cart-count]').forEach((node) => {
    node.textContent = count;
    node.hidden = count === 0;
  });
};

const renderCart = (cart) => {
  if (!cartDrawer) return;
  const itemsNode = cartDrawer.querySelector('[data-cart-drawer-items]');
  const footer = cartDrawer.querySelector('[data-cart-drawer-footer]');
  const count = cartDrawer.querySelector('[data-cart-drawer-count]');
  const total = cartDrawer.querySelector('[data-cart-drawer-total]');
  const threshold = Number(cartDrawer.dataset.freeShipping || 0);
  const progressWrap = cartDrawer.querySelector('[data-shipping-progress-wrap]');
  const progress = cartDrawer.querySelector('[data-shipping-progress]');
  const message = cartDrawer.querySelector('[data-shipping-message]');

  count.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
  total.textContent = money(cart.total_price);
  footer.hidden = cart.item_count === 0;
  updateCartCount(cart.item_count);

  if (cart.item_count === 0) {
    const deluxeUrl = configuredRoutes.deluxe || storefrontRoute('collections/deluxe');
    const futureUrl = configuredRoutes.future || storefrontRoute('collections/future-division');
    itemsNode.innerHTML = '<div class="cart-drawer__empty"><p>Votre sélection est vide.</p><a class="button button--full" href="' + escapeHtml(deluxeUrl) + '">Découvrir Deluxe</a><a class="text-link" href="' + escapeHtml(futureUrl) + '">Voir Future Division</a></div>';
  } else {
    itemsNode.innerHTML = cart.items.map((item) => {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span>' + escapeHtml(item.variant_title) + '</span>' : '';
      const image = item.image ? '<a href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy"></a>' : '';
      return '<article class="cart-drawer-item">' + image + '<div class="cart-drawer-item__info"><a href="' + escapeHtml(item.url) + '"><strong>' + escapeHtml(item.product_title) + '</strong></a>' + variant + '<div class="cart-drawer-item__bottom"><div class="cart-drawer-quantity"><button type="button" data-cart-change data-key="' + escapeHtml(item.key) + '" data-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Réduire">−</button><span>' + item.quantity + '</span><button type="button" data-cart-change data-key="' + escapeHtml(item.key) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Augmenter">+</button></div><strong>' + money(item.final_line_price) + '</strong></div><button class="cart-drawer-item__remove" type="button" data-cart-change data-key="' + escapeHtml(item.key) + '" data-quantity="0">Retirer</button></div></article>';
    }).join('');
  }

  if (threshold > 0) {
    const remaining = Math.max(0, threshold - cart.total_price);
    const percent = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    progressWrap.hidden = false;
    progress.style.width = percent + '%';
    message.textContent = remaining > 0 ? 'Plus que ' + money(remaining) + ' pour la livraison offerte.' : 'Livraison offerte débloquée.';
  } else {
    progressWrap.hidden = true;
  }
};

const openCart = async (trigger = document.activeElement) => {
  if (!cartShell) return;
  lastCartTrigger = trigger;
  cartShell.hidden = false;
  document.body.classList.add('cart-open');
  requestAnimationFrame(() => cartShell.setAttribute('data-open', ''));
  renderCart(await fetchCart());
  cartDrawer?.querySelector('[data-cart-close]')?.focus();
};

const closeCart = () => {
  if (!cartShell) return;
  cartShell.removeAttribute('data-open');
  document.body.classList.remove('cart-open');
  setTimeout(() => {
    cartShell.hidden = true;
    lastCartTrigger?.focus?.();
    lastCartTrigger = null;
  }, 300);
};

const addVariant = async (id, quantity) => {
  const response = await fetch(storefrontRoute('cart/add.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: Number(id), quantity: Number(quantity || 1) })
  });
  if (!response.ok) throw new Error('Cart error');
  await openCart();
};

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form) return;
  event.preventDefault();
  const submit = form.querySelector('[type="submit"]');
  const original = submit.textContent;
  submit.disabled = true;
  submit.textContent = 'Ajout en cours…';
  try {
    const response = await fetch(storefrontRoute('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Cart error');
    submit.textContent = 'Ajouté au panier';
    announce('Produit ajouté au panier.');
    await openCart();
  } catch (_) {
    submit.textContent = 'Réessayer';
    announce('Impossible d’ajouter ce produit. Vérifiez la variante sélectionnée.');
  } finally {
    setTimeout(() => { submit.textContent = original; submit.disabled = false; }, 1400);
  }
});

document.addEventListener('click', async (event) => {
  const menuButton = event.target.closest('[data-menu-toggle]');
  if (menuButton) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    menu?.toggleAttribute('data-open', !open);
    menu?.setAttribute('aria-hidden', String(open));
    document.body.classList.toggle('menu-open', !open);
    if (!open) menu?.querySelector('[data-menu-close]')?.focus();
  }

  if (event.target.closest('[data-menu-close]')) {
    const menu = document.querySelector('[data-mobile-menu]');
    const toggle = document.querySelector('[data-menu-toggle]');
    menu?.removeAttribute('data-open');
    menu?.setAttribute('aria-hidden', 'true');
    toggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
    toggle?.focus();
  }

  if (event.target.closest('[data-cart-open]')) {
    event.preventDefault();
    try { await openCart(event.target.closest('[data-cart-open]')); }
    catch (_) { announce('Impossible de charger le panier. Réessayez dans un instant.'); }
  }
  if (event.target.closest('[data-cart-close]')) closeCart();

  const addButton = event.target.closest('[data-quick-add]');
  if (addButton) {
    event.preventDefault();
    const original = addButton.textContent;
    addButton.disabled = true;
    addButton.textContent = 'Ajout…';
    try {
      await addVariant(addButton.dataset.variantId, 1);
      addButton.textContent = 'Ajouté';
      announce('Produit ajouté au panier.');
    } catch (_) {
      addButton.textContent = 'Indisponible';
      announce('Ce produit ne peut pas être ajouté pour le moment.');
    }
    setTimeout(() => { addButton.textContent = original; addButton.disabled = false; }, 1400);
  }

  const changeButton = event.target.closest('[data-cart-change]');
  if (changeButton) {
    changeButton.disabled = true;
    try {
      const response = await fetch(storefrontRoute('cart/change.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: changeButton.dataset.key, quantity: Number(changeButton.dataset.quantity) })
      });
      if (!response.ok) throw new Error('Cart update error');
      renderCart(await response.json());
      announce('Panier mis à jour.');
    } catch (_) {
      changeButton.disabled = false;
      announce('Impossible de mettre le panier à jour.');
    }
  }

  const filterButton = event.target.closest('[data-filter-toggle]');
  if (filterButton) {
    const panel = document.querySelector('[data-filter-panel]');
    const open = filterButton.getAttribute('aria-expanded') === 'true';
    filterButton.setAttribute('aria-expanded', String(!open));
    panel.hidden = open;
  }

  if (event.target.closest('[data-size-guide-open]')) {
    const shell = document.querySelector('[data-size-guide-shell]');
    lastSizeGuideTrigger = event.target.closest('[data-size-guide-open]');
    shell.hidden = false;
    requestAnimationFrame(() => {
      shell.setAttribute('data-open', '');
      shell.querySelector('.size-guide-modal')?.focus();
    });
  }
  if (event.target.closest('[data-size-guide-close]')) {
    const shell = document.querySelector('[data-size-guide-shell]');
    shell.removeAttribute('data-open');
    setTimeout(() => {
      shell.hidden = true;
      lastSizeGuideTrigger?.focus?.();
      lastSizeGuideTrigger = null;
    }, 250);
  }

  if (event.target.closest('[data-sticky-add]')) document.querySelector('[data-product-form]')?.requestSubmit();
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.selectedOptions[0];
  const form = select.closest('form');
  const idInput = form?.querySelector('[name="id"]');
  const price = document.querySelector('[data-product-price]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const submit = form?.querySelector('[type="submit"]');
  const stickySubmit = document.querySelector('[data-sticky-add]');
  const available = option.dataset.available === 'true';
  if (idInput) idInput.value = option.value;
  if (price && option.dataset.price) price.textContent = money(Number(option.dataset.price));
  if (stickyPrice && option.dataset.price) stickyPrice.textContent = money(Number(option.dataset.price));
  [submit, stickySubmit].forEach((button) => { if (button) { button.disabled = !available; button.textContent = available ? (button === stickySubmit ? 'Ajouter' : 'Ajouter au panier') : 'Épuisé'; } });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  closeCart();
  const menu = document.querySelector('[data-mobile-menu]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  menu?.removeAttribute('data-open');
  menu?.setAttribute('aria-hidden', 'true');
  menuToggle?.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('menu-open');
  const sizeGuide = document.querySelector('[data-size-guide-shell]');
  if (sizeGuide && !sizeGuide.hidden) {
    sizeGuide.removeAttribute('data-open');
    setTimeout(() => {
      sizeGuide.hidden = true;
      lastSizeGuideTrigger?.focus?.();
      lastSizeGuideTrigger = null;
    }, 250);
  }
});

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => { if (entry.isIntersecting) entry.target.dataset.visible = 'true'; });
}, { threshold: 0.08 });
document.querySelectorAll('[data-reveal]').forEach((node) => observer.observe(node));

document.querySelectorAll('product-recommendations[data-url]').forEach(async (section) => {
  try {
    const html = await fetch(section.dataset.url).then((response) => response.text());
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations');
    if (fresh?.innerHTML.trim()) section.innerHTML = fresh.innerHTML;
  } catch (_) { /* Optional enhancement. */ }
});
